import React from 'react';
import loaderSvg from '../../assets/loader.svg';

const Spinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <img src={loaderSvg} alt="Loading" className="w-16 h-16" />
    </div>
  );
};

export default Spinner;
